export default __webpack_public_path__ + "static/media/AngelLovelace.6fbd5cc1.png";